import { useLocale } from "next-intl";
import Image from "next/image";
import { FC } from "react";

import useMediaQuery from "@/hooks/useMediaQuery";

import { ImageTextAmenityColumn, LayoutType } from "./type";

interface CardTabTextImageProp {
  column: ImageTextAmenityColumn;
}

const CardTabTextImage: FC<CardTabTextImageProp> = ({ column }) => {
  const locale = useLocale();
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  return (
    <>
      <div className={`flex flex-col items-center ${column.layout === LayoutType.HORIZONTAL ? "w-fix-tab-card justify-end" : "aspect-3-4"}`}>
        {column.textPosition === "top" && (
          <div className={`${column.layout === LayoutType.HORIZONTAL ? "w-full" : "h-1-7"}`}>
            <p className={`pb-l ${locale?.split("-")[0] === "ar" ? "text-card-tab-paragraph" : "text-card-tab"}`}>{column.text.slice(0, 180)}</p>
          </div>
        )}
        <div className={`${column.layout === LayoutType.HORIZONTAL ? "w-full" : "h-[210px] md:h-[450px] rounded-xl"}`}>
          <Image
            className={`object-cover rounded-xl ${column.layout === LayoutType.HORIZONTAL ? "w-full" : "w-[224px] h-[210px] md:w-[394px] md:h-[450px]"}`}
            src={column?.image?.url}
            alt={column?.text}
            width={`${column.layout === LayoutType.VERTICAL ? "450" : isDesktop ? "394" : "280"}`}
            height={`${column.layout === LayoutType.VERTICAL ? "600" : isDesktop ? "450" : "210"}`}
          />
        </div>
        {column.textPosition === "bottom" && (
          <div className={`${column.layout === LayoutType.HORIZONTAL ? "h-1-7 w-full" : "h-1-7"}`}>
            <p
              className={`${locale?.split("-")[0] === "ar" ? "text-card-tab-paragraph" : "text-card-tab"} pb-0 font-secondary-light ${column.layout === LayoutType.HORIZONTAL ? " pt-l" : "pt-l max-h-2xl md:max-h-xl"}`}
            >
              {column.text.slice(0, 180)}
            </p>
          </div>
        )}
      </div>
    </>
  );
};
export default CardTabTextImage;
